<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
    name: "app",
    data() {
        return {}
    },
    methods: {},
    created() {
        /* window.addEventListener('storage', res => { //监听保持同一浏览器，只允许一登录一个帐号
            if (res.key === 'is_activation' || res.key === null || res.key==='user_login') {
                window.location.reload()
            }
        }) */
    }
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

</style>
